<template>
  <div class="mainContent">
    <Maintain></Maintain>
    <router-view></router-view>
  </div>
</template>

<script>
import Maintain from '@/component/maintain.vue';
export default {
  name: 'layoutBlank',
  components: {
    Maintain
  },
  data: function () {
    return {};
  },
  created: function () {},
  methods: {},
  mounted() {
    // var map = new BMap.Map("container");
    // var point = new BMap.Point(116.404, 39.915);
  },
};
</script>

<style lang="less">
  .mainContent{
    background: #EBEBEB;
  }
</style>

<style>
  /* #newBridge{
    display: none !important;
  } */
</style>
